import _ from "lodash";
import { IFieldInstance } from "../../../types/fieldInstance.interface";
import FormInput, { FormProps } from "../input/FormInput";

interface ICustomWoundComp extends FormProps {
  getErrorMessage: any;
  errorMessage?: any;
  values: any;
  fieldName?: string;
  allWoundFields: IFieldInstance[];
  mainLabel?: string;
}

function getFieldName(
  isRLField: boolean,
  fieldName: string,
  name: string
): string {
  let newName = name;
  if (isRLField) {
    const dotIndex = fieldName.lastIndexOf(".");
    newName = fieldName.slice(0, dotIndex + 1) + name;
  }
  return newName;
}

function getWoundFields(
  childWoundFields: IFieldInstance[],
  fieldDetails: { [key: string]: any }
) {
  const isRLField = !childWoundFields.some(
    (childWoundField) => childWoundField.fieldName === fieldDetails.name
  );
  const woundFieldIds = childWoundFields.map(
    (childWoundField) => childWoundField.id
  );
  const parentFields = childWoundFields.filter(
    (childWoundField) => !woundFieldIds.includes(childWoundField.parentFieldId)
  );
  const parentField =
    parentFields.length && parentFields.length !== 1
      ? parentFields.find((field) => field.fieldName === fieldDetails.name)
      : parentFields[0];
  let childFields;
  let parentFieldDetails;
  if (parentField) {
    parentFieldDetails = {
      name: getFieldName(isRLField, fieldDetails.name, parentField.fieldName),
      label: parentField.fieldLabel,
    };
    childFields = childWoundFields
      .filter(
        (childWoundField) => childWoundField.parentFieldId === parentField?.id
      )
      .map((childField) => {
        return {
          name: getFieldName(
            isRLField,
            fieldDetails.name,
            childField.fieldName
          ),
          label: childField.fieldLabel,
        };
      });
  }
  return parentFieldDetails ? [parentFieldDetails, ...(childFields || [])] : [];
}

function getFieldValue(
  fieldName: string,
  allValues: { [key: string]: string }
) {
  return !(fieldName in allValues)
    ? _.get(allValues, fieldName)
    : allValues[fieldName];
}

const CustomWoundComp = ({
  values,
  value,
  fieldName,
  onChange,
  getErrorMessage,
  isImportant,
  errorMessage,
  disabled,
  onBlur,
  allWoundFields,
  label,
  mainLabel,
}: ICustomWoundComp) => {
  const woundFields = getWoundFields(allWoundFields, {
    name: fieldName,
    label,
  });

  return (
    <div className="p-5">
      <label className="font-semibold">
        {" "}
        {mainLabel ?? "Provide wound dimensions if applicable"}{" "}
      </label>
      <div className="flex">
        {woundFields.map((woundField) => (
          <FormInput
            key={woundField.name}
            name={woundField.name}
            label={woundField.label}
            value={getFieldValue(woundField.name, values)}
            errorMessage={
              errorMessage
                ? errorMessage[`${woundField.name}`]
                : getErrorMessage(woundField.name, true)
            }
          >
            <input
              data-testid={`custom-wound-comp-${woundField.name}`}
              name={woundField.name}
              type="text"
              value={getFieldValue(woundField.name, values)}
              onChange={onChange}
              required={isImportant}
              onBlur={onBlur}
              disabled={disabled}
              className="h-8 border-none bg-gray-300 px-3"
            />
          </FormInput>
        ))}
      </div>
    </div>
  );
};

export default CustomWoundComp;
